import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IApiResponse,
  IGetStoreRequestDto,
  IGhlDto,
  IKitchenHubDto,
  IKitchenHubStoreDto,
} from '../models';

@Injectable()
export class KitchenService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getKitchenHubSettings(id: number): Observable<IKitchenHubDto> {
    return this.get(`admin/features/kitchen/${id}`);
  }

  public updateKitchenHubSettings(
    model: IKitchenHubDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/kitchen`, model);
  }

  public getGhlSettings(id: number): Observable<IGhlDto> {
    return this.get(`admin/features/ghl/${id}`);
  }

  public updateGhlSettings(model: IGhlDto): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/ghl`, model);
  }

  public getStores(
    model: IGetStoreRequestDto
  ): Observable<IKitchenHubStoreDto[]> {
    return this.post(`admin/features/kitchen/getStores`, model);
  }

  public connectStore(
    model: IGetStoreRequestDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/features/kitchen/connectStore`, model);
  }
}
